import { call, select } from 'redux-saga/effects';

import { getSiteContacts } from 'features/order-tracker/api/orderTrackerApi';
import { getCurrentAppointmentInfoToAmend, getOrderSummary } from 'features/order-tracker/store/selectors';

export function* getSiteContactsRequest() {
  const { itemId, orderKey } = yield select(getCurrentAppointmentInfoToAmend);
  const { postcode } = yield select(getOrderSummary);

  return yield call(getSiteContacts, orderKey, itemId, postcode);
}
